import styles from './EmotionRadio.module.scss';
import EmotionList from './Emotions';

export interface EmotionRadioProps
  extends React.ButtonHTMLAttributes<HTMLInputElement> {
  emotion: 'neutral' | 'excited' | 'nervous' | 'tired' | 'content' | 'happy';
}

function EmotionRadio({
  emotion,
  ...inputProps
}: EmotionRadioProps): JSX.Element {
  const activeEmotion = EmotionList[emotion];

  return (
    <div className={styles.wrapper}>
      <input
        {...inputProps}
        id={`RadioInput-${activeEmotion.label}`}
        className={styles.hiddenInput}
        aria-label={activeEmotion.label}
        type="radio"
      />
      <label htmlFor={`RadioInput-${activeEmotion.label}`} aria-hidden>
        <figure>
          <img src={activeEmotion.emoji} alt={activeEmotion.label} />
          <figcaption>{activeEmotion.label}</figcaption>
        </figure>
      </label>
    </div>
  );
}

export default EmotionRadio;
